var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"grid-list-xs":""}},[_c('v-card',{attrs:{"outlined":"","height":_vm.vsh-250}},[_c('mbs-page-tab',{attrs:{"items":_vm.MY_LINKS}}),_c('v-layout',{attrs:{"fill-height":"","column":"","justify-center":"","align-center":""}},[_c('h1',[_vm._v("Coming Soon!..")])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }